import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('nf_token'));

  const api = useCallback(() => {
    const instance = axios.create({
      baseURL: API,
      withCredentials: true,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return instance;
  }, [token]);

  const checkAuth = useCallback(async () => {
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api().get('/auth/me');
      setUser(data.user);
    } catch {
      setUser(null);
      setToken(null);
      localStorage.removeItem('nf_token');
    } finally {
      setLoading(false);
    }
  }, [token, api]);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (phone, password) => {
    const { data } = await api().post('/auth/login', { phone, password });
    setToken(data.token);
    localStorage.setItem('nf_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api().post('/auth/register', payload);
    setToken(data.token);
    localStorage.setItem('nf_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api().post('/auth/logout'); } catch {}
    setUser(null);
    setToken(null);
    localStorage.removeItem('nf_token');
  };

  const updateUser = (u) => setUser(u);

  return (
    <AuthContext.Provider value={{ user, loading, token, login, register, logout, updateUser, api: api() }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
